/** Base64url-encode a design URN for Model Derivative API paths. */
export function encodeModelDerivativeUrn(urn: string): string {
  return btoa(urn).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}

/**
 * Document id for LMV `Document.load` — the viewer atob-decodes the part
 * after `urn:`, so this must be base64url, not the raw wipprod URN.
 */
export function encodeViewerDocumentId(versionUrn: string): string {
  return `urn:${encodeModelDerivativeUrn(versionUrn)}`;
}
